import { CompleteActivitySummaryData } from "../complete-activity-summary/complete-activity-summary-data";

export class CompleteActivityUninstallSignatureData {
    summary: CompleteActivitySummaryData;
    merchantMember: string;
    merchantEmail: string;
}